<div class="slotPicker" [class.withTimes]="isTimeSlot && selectedDate">
  <!-- 1 - Calendar -->
  <section class="slotPickerCard">
    <div class="slotPickerHeader">
      <span class="slotPickerEyebrow">
        <span>{{ 'TIME_SLOTS.PICK_DATE' | translate }}</span>
      </span>
    </div>
    <ion-datetime id="availableDatesCalendar" presentation="date" size="cover" [min]="min" [max]="max" (ionChange)="dateChange.emit($event)" [highlightedDates]="highlightedDates" [isDateEnabled]="isDateEnabled"></ion-datetime>
    <div *ngIf="hasDatePromotions" class="slotPickerLegend slotPickerPromotionLegend">
      <span class="slotPickerLegendDot" aria-hidden="true"></span>
      <span>{{ 'DATE_PROMOTION.CALENDAR_LEGEND' | translate }}</span>
    </div>
    <div *ngIf="hasPrivatizedException" class="slotPickerLegend">
      <span class="slotPickerLegendDot" aria-hidden="true"></span>
      <span>{{ 'TIME_SLOTS.PRIVATIZATION' | translate }}</span>
    </div>
  </section>

  <!-- 2 - Time slots, once a date is selected -->
  <section *ngIf="isTimeSlot && selectedDate" class="slotPickerCard slotPickerTimes">
    <div class="slotPickerHeader">
      <span class="slotPickerEyebrow">
        <span>{{ 'TIME_SLOTS.PICK_TIME' | translate }}</span>
      </span>
      <span class="slotPickerDateTag">{{ selectedDate | date:'mediumDate' }}</span>
    </div>
    <p *ngIf="timeSlots.length === 0" class="slotPickerEmpty">{{ 'TIME_SLOTS.NO_SLOT_AVAILABLE' | translate }}</p>
    <div *ngIf="timeSlots.length > 0" class="slotPickerPills" role="group" [attr.aria-label]="'TIME_SLOTS.PICK_TIME' | translate">
      <button type="button" *ngFor="let timeSlot of timeSlots; trackBy: trackBySlotLabel" class="slotPill" [class.selected]="timeSlot.isSelected" [disabled]="isSlotFull(timeSlot)" [attr.aria-pressed]="timeSlot.isSelected" (click)="slotToggle.emit(timeSlot)">
        {{ timeSlot.displayLabel || timeSlot.label }}
      </button>
    </div>
  </section>
</div>

<!-- Selection recap -->
<div *ngIf="selectedDate" class="slotSelectionSummary">
  <div class="slotSelectionChips">
    <span class="slotChip">
      <svg class="slotChipIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M7 3v3M17 3v3M4 9h16M6 5h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" />
      </svg>
      <span class="slotChipLabel"><span class="slotChipKey">{{ 'TIME_SLOTS.DATE' | translate }}</span> {{ selectedDate | date:'mediumDate' }}</span>
    </span>
    <ng-container *ngIf="isTimeSlot && selectedSlot?.label">
      <span class="slotChip removable">
        <svg class="slotChipIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 7v5l3 2M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" />
        </svg>
        <span class="slotChipLabel"><span class="slotChipKey">{{ 'TIME_SLOTS.TIME' | translate }}</span> {{ selectedSlot?.displayLabel || selectedSlot?.label }}</span>
        <button type="button" class="slotChipRemove" (click)="removeSelectedSlot()" [attr.aria-label]="'TIME_SLOTS.REMOVE_TIME' | translate" [title]="'TIME_SLOTS.REMOVE_TIME' | translate">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="3" stroke-linecap="round" fill="none" />
          </svg>
        </button>
      </span>
      <span *ngIf="durationMinutes" class="slotChip">
        <svg class="slotChipIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M7 3h10M7 21h10M8 3v3a4 4 0 0 0 8 0V3M8 21v-3a4 4 0 0 1 8 0v3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" />
        </svg>
        <span class="slotChipLabel"><span class="slotChipKey">{{ 'TIME_SLOTS.DURATION' | translate }}</span> {{ durationMinutes }} {{ 'GENERIC.MINUTES' | translate }}</span>
      </span>
    </ng-container>
  </div>
  <span *ngIf="remainingTickets !== null" class="slotBadge">{{ 'TIME_SLOTS.AVAILABLE_TICKETS' | translate }} {{ remainingTickets }}</span>
</div>
